module.exports = fox._r("fonts/ostrich-sans-black.svg", __webpack_public_path__ + "_/_/_/root/fonts/ostrich-sans-black.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-black.svg
// module id = 174
// module chunks = 4